export default __webpack_public_path__ + "static/hero-e1ef1dc3f330141a27071c47e8758667.png";